
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/assets/partnerships",
      function () {
        return require("private-next-pages/docs/assets/partnerships/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/assets/partnerships"])
      });
    }
  